// Физический размер SVG из width/height корневого <svg>, в мм.
// null, если размер не определён (нет width/height, проценты, мусор).
// CSS-единицы: 96px = 1in = 25.4мм; безразмерные значения = user units = px.

const MM_PER = { mm: 1, cm: 10, in: 25.4, pt: 25.4 / 72, pc: 25.4 / 6, px: 25.4 / 96 }

function lengthToMm(v) {
  if (v == null) return null
  const m = String(v).trim().match(/^([+-]?[0-9]*\.?[0-9]+)\s*(mm|cm|in|pt|pc|px)?$/i)
  if (!m) return null
  const n = parseFloat(m[1])
  if (!Number.isFinite(n)) return null
  return n * MM_PER[(m[2] || "px").toLowerCase()]   // без единицы → px (CSS user units)
}

export function svgPhysicalSizeMm(text) {
  if (!text) return null
  const tag = String(text).match(/<svg\b[^>]*>/i)
  if (!tag) return null
  // \s перед именем, чтобы stroke-width не матчился как width
  const attr = (name) => {
    const m = tag[0].match(new RegExp(`\\s${name}\\s*=\\s*["']([^"']+)["']`, "i"))
    return m ? m[1] : null
  }
  const w = lengthToMm(attr("width")), h = lengthToMm(attr("height"))
  return w && h && w > 0 && h > 0 ? { w, h } : null
}
